import { render, staticRenderFns } from "./m_invest019.vue?vue&type=template&id=154e7054&"
import script from "./m_invest019.vue?vue&type=script&lang=js&"
export * from "./m_invest019.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports